import { apiGet } from "./api_methods";
import { RECRUITER_TRANSACTIONS_BASE } from "./endpoints";

/**
 * Fetches paginated transaction history for the logged-in recruiter.
 * Also returns aggregated credit summary (usedCredits, remainingCredits, totalCredits).
 *
 * GET /v1/recruiter/transactions
 *
 * @param {Object} [params]
 * @param {number} [params.skip=0] - Records to skip for pagination
 * @param {number} [params.limit=9] - Records per page
 * @param {string|null} [params.transactionId] - Fetch a single transaction by ID
 * @returns {Promise<{ body, status }>}
 */
export async function getTransactions(params = {}) {
  const q = {};
  if (params.skip != null) q.skip = params.skip;
  if (params.limit != null) q.limit = params.limit;
  if (params.transactionId) q.transactionId = params.transactionId;

  const query = new URLSearchParams(q).toString();
  const path = query
    ? `${RECRUITER_TRANSACTIONS_BASE}?${query}`
    : RECRUITER_TRANSACTIONS_BASE;
  return apiGet(path);
}
